// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const landorus_incarnate: PokeData = {
  "id": 645,
  "name": "landorus-incarnate",
  "height": 15,
  "weight": 680,
  "base_experience": 270,
  "types": [
    PokeType.GROUND,
    PokeType.FLYING
  ],
  "api_moves": [
    "swords-dance",
    "tackle",
    "leer",
    "bite",
    "rock-throw",
    "earthquake",
    "fissure",
    "rock-slide",
    "outrage",
    "sandstorm",
    "twister",
    "crunch",
    "imprison",
    "rock-tomb",
    "extrasensory",
    "sand-tomb",
    "block",
    "bulk-up",
    "mud-shot",
    "hammer-arm",
    "punishment",
    "earth-power",
    "stone-edge",
    "smack-down",
    "bulldoze",
    "sandsear-storm"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "rock-throw",
    "earthquake",
    "fissure",
    "rock-slide",
    "outrage",
    "sandstorm",
    "crunch",
    "rock-tomb",
    "bulk-up",
    "mud-shot"
  ],
  "evolution_chain": {
    "id": 332,
    "item": null,
    "species": [
      {
        "name": "landorus",
        "order": 646,
        "types": [
          PokeType.GROUND,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 129,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
